import React from 'react';
import T from 'prop-types';

const AnchorLine = ({ selected, offsetLeft }) => {
  return (
    <div
      className={`marker-anchor-line ${selected ? 'marker-anchor-line--selected' : ''}`}
      style={{ left: offsetLeft }}
    />
  );
};

AnchorLine.propTypes = {
  selected: T.bool.isRequired,
  offsetLeft: T.number.isRequired,
};

export default AnchorLine;
